import React from "react";

import SyDialog from "../../../components/SyDialog";
import { formatMoney } from "../../orders/format";

const PaymentMethodSheet = ({ payment, onClose }) => (
  <SyDialog open title="Choose a payment method" onClose={onClose}>
    <div className="sy-flow-choices" role="radiogroup" aria-label="Payment method">
      {payment.methods.map((method) => {
        const selected = method.code === payment.selectedCode;

        return (
          <button
            key={method.code}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={method.enabled === false}
            className={`sy-flow-choice${selected ? " is-selected" : ""}`}
            onClick={() => {
              payment.selectMethod(method.code);
              onClose();
            }}
          >
            <span className="sy-flow-choice-radio" aria-hidden="true" />

            <span className="sy-flow-choice-body">
              <span className="sy-flow-choice-title">{method.title}</span>

              {method.description && (
                <span className="sy-flow-choice-meta">{method.description}</span>
              )}

              {method.balance && (
                <span className="sy-flow-choice-meta">
                  Balance {formatMoney(method.balance)}
                </span>
              )}

              {method.enabled === false && method.disabledReason && (
                <span className="sy-flow-choice-blocked">{method.disabledReason}</span>
              )}
            </span>
          </button>
        );
      })}

      {!payment.methods.length && (
        <p className="sy-flow-choice-empty">No payment method is available right now.</p>
      )}
    </div>
  </SyDialog>
);

export default PaymentMethodSheet;
